module.exports = __webpack_public_path__ + "img/banner16.dc451a68.png";